import React from "react";
import "./ClearButton.scss"


const ClearButton = ({clearAllFeedbacks}) =>
{


    // const clearAllFeedbacks = () => 
    // {
    //     // setAnnotations([]);
    // }


    return (
    <button className="clear_feedback_button" onClick={clearAllFeedbacks} style={{ margin: "2px" }}
    title="Clear all feedbacks">
        <img src="/assets/clear.png" />
    </button>

    );

};

export default ClearButton;